import { getTitleBase, getCorrectOffSalesRegion } from "../shared/util";
import Helmet from "react-helmet";
import { Link } from "react-router";
import React, { Component } from "react";
import CarouselWrapper from "../shared/carousel-wrapper";
import Slide from "./slide";

import "./our-advantage.scss";
class OurAdvantage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slides: [
        {
          videoUrl:
            "//players.brightcove.net/5699924528001/default_default/index.html?videoId=6249085684001&muted&autoplay&playsinline&loop",
        },
        {
          videoUrl:
            "//players.brightcove.net/5699924528001/default_default/index.html?videoId=6204224647001&muted&autoplay&playsinline&loop",
        },
      ],
    };
    this.mainRef = React.createRef();
  }

  render() {
    const title = `Our Advantage - ${getTitleBase(this.props.entity)}`;
    return (
      <div>
        <Helmet>
          <title dangerouslySetInnerHTML={{ __html: title }} />
          <meta property="og:title" content={title} />
          <meta
            name="description"
            content={`Our Advantage ${
              this.props.entity.displayName
            }, ${getCorrectOffSalesRegion(this.props.entity)} | ${
              this.props.entity.brand
            } Inc.`}
          />
        </Helmet>
        <div className="iframeHolder">
          <iframe
            className="brandEssense"
            src="//players.brightcove.net/5699924528001/default_default/index.html?videoId=6286663702001&muted&autoplay&playsinline&loop"
            frameBorder="0"
            allowFullScreen={true}
          ></iframe>
        </div>
        <div className="our-advantage-section">
          <div className="our-advantage-indi container web-container">
            <h2 className="header-standard customTextHeading">Our Advantage</h2>
            <div className="header-separator"></div>
            <p className="header-text customTextSubHeading">
              Setting the world’s highest standard.
            </p>
            <p className="content">
              Established in 1976, Sotheby’s International Realty has become the
              world’s premier luxury residential real estate brokerage. Through
              our vast global footprint, local expertise, and unequalled
              referral network, we ensure that the properties we represent
              receive the far-reaching and unparalleled exposure they deserve.
            </p>
            <div className="about-us">
              {/* <a
                target="_blank"
                href="https://www.sothebysrealty.com/eng/about-sir"
              >
                <button className="aw-button">About us</button>
              </a> */}
            </div>
            <div className="siteNumbers">
              <div className="section">
                <div className="text">GLOBAL REACH</div>
                <div className="numbers">84</div>
                <div className="subText">Countries & Territories</div>
              </div>
              <div className="section">
                <div className="text">OUR NETWORK</div>
                <div className="numbers">1,100</div>
                <div className="subText">Offices Worldwide</div>
              </div>
              <div className="section">
                <div className="text">LOCAL EXPERTISE</div>
                <div className="numbers">26,100</div>
                <div className="subText">Sales Associates</div>
              </div>
              <div className="section">
                <div className="text">ACHIEVEMENT</div>
                <div className="numbers">$157B</div>
                <div className="subText">Annual Sales (USD)</div>
              </div>
            </div>
            <div className="ourBrand">
              <div className="ourBrandImage">
                <img src="img/our-advantage/Modernist-Evening-Auction.jpg"></img>
              </div>
              <div className="ourBrandContent">
                <div className="header">
                  Our brand. <br />
                  Your benefit.
                </div>
                <div className="subHeader">
                  The Sotheby’s International Realty® brand is built on the
                  centuries-long prestige of the world’s preeminent auction
                  house. Sotheby’s history and our unmatched reputation give our
                  listings the best-in-class exposure they deserve and assures
                  buyers they are working with a trusted partner.
                </div>
                <div className="auction">
                  <a
                    target="_blank"
                    href="https://www.sothebysrealty.com/eng/auction-house"
                  >
                    <button className="aw-button">SOTHEBY’S AUCTION</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sell-withus-section">
          <div className="sell-withus container web-container">
            <h2 className="header-standard customTextHeading">
              SELL WITH{" "}
              {this.props.entity.entityType === 2 &&
              this.props.entity.teamMembers &&
              this.props.entity.teamMembers.length > 1
                ? "US"
                : "ME"}
            </h2>
            <div className="header-separator"></div>
            <p className="header-text customTextSubHeading">
              Don’t just get it on the market. <br />
              Get it the attention it deserves.
            </p>
            <p className="content">
              For those who demand an elevated service like none other, there’s
              Sotheby’s International Realty. We’re the industry’s best agents,
              curating with incomparable attention to style and detail. We’re
              here for you to help sell your home at a scale you just won’t find
              anywhere else.
            </p>
            <div className="videoSection">
              <CarouselWrapper
                slides={this.state.slides.map((slide, index) => (
                  <Slide
                    index={index}
                    numSlides={this.state.slides.length}
                    slide={slide}
                    key={index}
                  />
                ))}
                autoPlayOverride={true}
              />
            </div>
            <div className="onlyWithUs">
              <div className="titleText">
                What you can get only with{" "}
                {this.props.entity.entityType === 2 &&
                this.props.entity.teamMembers &&
                this.props.entity.teamMembers.length > 1
                  ? "us"
                  : "me"}
                :
              </div>
              <div className="onlyWithUsContent">
                <div className="adv">UNRIVALED MARKETING</div>
                <div className="adv">EXCLUSIVE PARTNERSHIPS</div>
                <div className="adv">PUBLIC RELATIONS POWERHOUSE</div>
                <div className="adv">BRAND HERITAGE & REPUTATION</div>
                <div className="adv">TRUE GLOBAL REACH</div>
                <div className="adv">UNMATCHED SERVICE</div>
              </div>
            </div>
            <div className="sell-with-us">
              <Link to="/contact">
                <button className="aw-button">
                  SELL WITH{" "}
                  {this.props.entity.entityType === 2 &&
                  this.props.entity.teamMembers &&
                  this.props.entity.teamMembers.length > 1
                    ? "US"
                    : "ME"}
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OurAdvantage;



// WEBPACK FOOTER //
// ./src/components/our-advantage/index.js